export const useRegionName = (locale: string) => new Intl.DisplayNames([locale], { type: 'region' });